import React, { useEffect } from "react";
import { Card, Button, Table, Space, Layout } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { GradeRange } from "../../../components/GradeRange";
import { pendingOrgs } from "../../../store/org/pending/PendingOrgsStore";
import { PendingOrgDlg } from "./PendingOrgDlg";

export const PendingOrgs = observer(() => {
  useEffect(() => {
    pendingOrgs.refresh();
  }, []);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Name",
      dataIndex: "name",
      key: "nama",
      width: "30%",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Grades",
      dataIndex: "grades",
      key: "grades",
      render: (_, r) => GradeRange(r),
    },
    // {
    //   title: "Active User Count",
    //   dataIndex: "activeUserCount",
    //   sorter: (a, b) => a.activeUserCount - b.activeUserCount,
    //   key: "count",
    // },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      sorter: (a, b) => (a.city || "").localeCompare(b.city || ""),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => (a.state || "").localeCompare(b.state || ""),
    },
    {
      title: "Notes",
      width: "40%",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => (a.description || "").localeCompare(b.description),
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => pendingOrgs.orgEdit.edit(r.id)} />,
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Card
        title="User School Addition"
        size="small"
        bodyStyle={{ padding: 0 }}
        extra={
          <Space>
            {/* <Button size="small" style={{ float: "right" }} onClick={() => store.orgEdit.edit()}>
            Add
          </Button> */}
            <Button
              loading={pendingOrgs.loading}
              size="small"
              style={{ float: "right" }}
              onClick={() => pendingOrgs.refresh()}
            >
              Refresh
            </Button>
          </Space>
        }
      >
        <Table
          size="small"
          loading={pendingOrgs.loading}
          // pagination={{ pageSize: 1500 }}
          rowKey="id"
          columns={columns}
          dataSource={pendingOrgs.data.items}
        />
        {pendingOrgs.orgEdit.visible && <PendingOrgDlg />}
      </Card>
    </Layout.Content>
  );
});
